const equipmentsRegistrationLimitWarning = {
  limitPercentage: {
    'appBar': 'Equipments limit at {{percentage}}%',
    'sideBar': '{{percentage}}% of equipments limit',
    'table': '{{percentage}}% of equipments limit',
  },
  registeredEquipments: 'Registered equipments',
  contactAccountables: 'Send email',
  reachedInfoPrefix: 'You have reached',
  reachedInfoSuffix: "your plan's equipment limit",
  reachedInfoText: 'upgrade to continue registering',
  notificationSuccessTitle: 'Notification sent',
  notificationSuccessText: 'Accountables have been successfully notified.',
  notificationErrorTitle: 'Error sending notification',
  notificationErrorText: 'Unable to send notification to accountables. Please try again.',
  upgradeInfo: 'to register more equipment you will need to upgrade. Click on "Send Email" or send an email to the following GAP accountables',
  noAccountables: 'No accountables',
  modalTitle: 'Equipments limit',
  messageSentTitle: 'Message sent!',
  messageSentText: 'One of our consultants will be in touch shortly.',
};

export default equipmentsRegistrationLimitWarning;
